import Radium, { StyleRoot } from "radium";
import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import GlobalStateProvider from "./Context/GlobalContext/GlobalState";
import About from "./Pages/About";
import AllBookList from "./Pages/AllBookList";
import Authors from "./Pages/Authors";
import BookList from "./Pages/BookList";
import Cart from "./Pages/Cart/Cart";
import Categories from "./Pages/Categories";
import Contact from "./Pages/Contact";
import Home from "./Pages/Home";
import Login from "./Pages/Login/Login";
import NotFound from "./Pages/NotFound";
import ProductDetails from "./Pages/ProductDetails";
import Publications from "./Pages/Publications";
import Register from "./Pages/Register/Register";
import Wishlist from "./Pages/Wishlist/Wishlist";

import GlobalFooter from "./Components/GlobalFooter";
import HeaderTopBar from "./Components/HeaderTopBar";
import Navbar from "./Components/NavbarNew/Navbar";
import NavMenu from "./Components/NavMenu";
import AuthStateProvider from "./Context/AuthState";
import Blog from "./Pages/Blog/Blog";
import BlogCategory from "./Pages/Blog/BlogCategory";
import BlogDetails from "./Pages/Blog/BlogDetails";
import BlogTag from "./Pages/Blog/BlogTag";
import Checkout from "./Pages/Checkout/Checkout";
import Page from "./Pages/Page/Page";
import Profile from "./Pages/Profile/Profile";
import ProtectedRoute from "./Services/ProtectedRoute";
function App() {
  return (
    <StyleRoot>
      <div className="">
        <Router>
        <HeaderTopBar />
          
          <Switch>
            <AuthStateProvider>
              <GlobalStateProvider>

              <Navbar/>
              <NavMenu/>
                <Route path="/" exact component={Home} />
                <Route
                  path="/product-details/:bookname"
                  exact
                  component={ProductDetails}
                />
                <Route
                  path="/books/authors/:id"
                  exact
                  component={BookList}
                />
                <Route
                  path="/books/publishers/:slug"
                  exact
                  component={BookList}
                />

                <Route path="/books/search/:name" exact component={BookList}/>

                <Route path="/books/" exact component={AllBookList} />
                <Route path="/authors/" exact component={Authors} />
                <Route path="/publications/" exact component={Publications} />
                <Route path="/categories/" exact component={Categories} />
                <Route
                  path="/books/categories/:slug"
                  exact
                  component={BookList}
                />
                <Route path="/about" exact component={About} />
                <Route path="/contact" exact component={Contact} />
                <Route path="/cart" exact component={Cart} />
                <ProtectedRoute path="/checkout" exact component={Checkout} />
                <ProtectedRoute path="/profile" exact component={Profile} />
                <Route path="/blog" exact component={Blog} />
                <Route
                  path="/blog/category/:slug"
                  exact
                  component={BlogCategory}
                />
                <Route path="/blog/tag/:slug" exact component={BlogTag} />
                <Route
                  path="/blog-details/:slug"
                  exact
                  component={BlogDetails}
                />
                <Route path="/login" exact component={Login} />
                <Route path="/register" exact component={Register} />
                <ProtectedRoute path="/wishlist" exact component={Wishlist} />

                {/* Footer Pages */}
                {/* Footer Pages End*/}

                <Route path="/page/:slug" exact component={Page} />
              </GlobalStateProvider>
            </AuthStateProvider>
            <Route exact component={NotFound} />
          </Switch>
          <GlobalFooter/>
        </Router>
      </div>
    </StyleRoot>
  );
}

export default Radium(App);

// this is new branch navbarResponsive trying to push to remote
